import axios from "axios"
import notice from "src/components/Notice"
import STORAGE, { deleteStorage, getStorage, getStorageCookie } from "src/lib/storage"
import { getMsgClient } from "src/lib/stringsUtils"
import { trimData } from "src/lib/utils"
import ROUTER from "src/router"
import { Modal } from "antd"
/**
 *
 * parse error response
 */
function parseError(messages) {
  // error
  if (messages) {
    if (messages instanceof Array) {
      return Promise.reject({ messages })
    }
    return Promise.reject({ messages: [messages] })
  }
  return Promise.reject({ messages: ["Server quá tải"] })
}

/**
 * parse response
 */

export function parseBody(response) {
  const status = +response?.status;
  const resData = response.data;

  // ================= ERROR HTTP =================
  if (status >= 500) {
    return notice({
      msg: "Hệ thống đang tạm thời gián đoạn. Xin vui lòng trở lại sau hoặc thông báo với ban quản trị để được hỗ trợ",
      isSuccess: false,
    });
  }

  if (status !== 200) {
    return notice({
      msg: `Hệ thống xảy ra lỗi. Xin vui lòng trở lại sau hoặc thông báo với ban quản trị để được hỗ trợ (SC${status})`,
      isSuccess: false,
    });
  }

  // ================= STATUS 200 =================
  return handleSuccessResponse(resData);
}

// ================= HANDLE SUCCESS =================
function handleSuccessResponse(resData) {
  if (resData.StatusCode === 401) {
    deleteStorage(STORAGE.TOKEN);
    window.location.replace(ROUTER.HOME_PAGE);
    return;
  }

  // case đặc biệt
  if (resData.Status === -2 || resData.Status === 0) {
    return resData;
  }

  // show notice
  if (shouldShowNotice(resData)) {
    notice({
      msg: getMsgClient(resData.Object),
      isSuccess: false,
    });
  }

  // transform object
  if (shouldTransformObject(resData)) {
    return {
      ...resData,
      object: getMsgClient(resData.Object),
    };
  }

  return resData;
}

// ================= HELPERS =================
const shouldShowNotice = (resData) =>
  resData.Status !== -1 &&
  resData.Status !== 69 &&
  resData.Object;

const shouldTransformObject = (resData) =>
  resData.Status !== 1 &&
  resData.Object;

/**
 * axios instance
 */
// const baseURL = ''
const instance = axios.create({
  // baseURL: '',
  timeout: 60000,
})

// request header
instance.interceptors.request.use(
  async config => {
    // Do something before request is sent
    if (config.data) {
      config.data =
        config.data instanceof FormData ? config.data : trimData(config.data)
    }
    config.headers = {
      Authorization: `Bearer ${getStorageCookie(STORAGE.TOKEN)}`,
      Accept: "application/json",
    }
    config.baseURL = process.env.REACT_APP_API_ROOT
    config.onUploadProgress = progressEvent => {

    }
    return config
  },
  error => Promise.reject(error),
)

instance.interceptors.response.use(
  response => parseBody(response),
  error => {
    if (+error?.response?.status === 403) {
      Modal.info({
        title: "🚫 Không có quyền truy cập",
        icon: null,
        content: (
          <div>
            Tài khoản của bạn không được phép thực hiện chức năng này. <br />
            Vui lòng liên hệ quản trị viên để được cấp quyền.
          </div>
        ),
        okText: "Đã hiểu",
      })
    }
    return Promise.reject(error)
  }
)


export default instance

export const httpGetFile = (path = "", optionalHeader = {}, params) =>
  instance({
    method: "GET",
    url: path,
    headers: { ...optionalHeader },
    responseType: 'blob',
    params
  })
